
export default [
    {
        path: 'client-partners',
        name: 'client-partners-group',
        component: () => import('source/pages/root/ClientEmployeesPageGroup.vue'),
        meta: {
            title: 'Client Partners - HQZen',
            canDisplayGlobalModals: true
        },
        children: [
            {
                path: '',
                name: 'client-partners',
                props: true,
                component: () => import('src/pages/client/ClientEmployeesPage.vue'),
                meta: {
                    title: 'Client Partners - HQZen',
                    canDisplayGlobalModals: true,
                    isInternal: true
                }
            },
            {
                path: 'client-partners/details',
                name: 'client-partner-details',
                component: () => import('src/pages/client/ClientEmployeeInfoPage.vue'),
                meta: {
                    title: 'Partner Details - HQZen',
                    canDisplayGlobalModals: true,
                    isInternal: true
                }
            },
        ]
    }
];
